// /src/data/TecnicosCalendly.ts
export interface TecnicoCalendly {
  email: string;
  nombre: string;
  calendly_url: string;
}

// Mapeo de técnicos con sus URLs de Calendly
// IMPORTANTE: Actualiza estas URLs después de crear las cuentas en Calendly
export const TECNICOS_CALENDLY: TecnicoCalendly[] = [
  {
    email: "nsanchez@oclem.com",
    nombre: "Grupo Oclem",
    calendly_url: "https://calendly.com/nsanchezarbitraje/30min",
  },
  {
    email: "lcampillo@oclem.com",
    nombre: "Grupo Oclem",
    calendly_url: "https://calendly.com/leticiaoclem/30min",
  },
  {
    email: "ycanadas@oclem.com",
    nombre: "Grupo Oclem",
    calendly_url: "https://calendly.com/ycanadasoclem/30min",
  },
  {
    email: "imartinez@oclem.com",
    nombre: "Grupo Oclem",
    calendly_url: "https://calendly.com/imartinezcam17/30min",
  },
  {
    email: "vmendez@oclem.com",
    nombre: "Grupo Oclem",
    calendly_url: "https://calendly.com/victormendezrodriguez10/30min",
  },
];

// Función para obtener la configuración de Calendly de un técnico por email
export const getTecnicoCalendlyByEmail = (
  email: string
): TecnicoCalendly | null => {
  return TECNICOS_CALENDLY.find((tecnico) => tecnico.email === email) || null;
};

// Función para verificar si un técnico tiene Calendly configurado
export const hasTecnicoCalendly = (email: string): boolean => {
  return TECNICOS_CALENDLY.some((tecnico) => tecnico.email === email);
};
